export default __webpack_public_path__ + "static/media/link-project.7ca68a1d.svg";